module.exports = __webpack_public_path__ + "img/tree-06-g-leaves.49f0a84a.png";